@if (display) {
	<p-dialog
		id="vehicleCategoryDialog"
		class="custom-dialog"
		[(visible)]="display"
		showEffect="fade"
		[modal]="true"
		[style]="{ width: '27vw', marginTop: '0px' }"
		[breakpoints]="{
			'1200px': '55vw',
			'1000px': '60vw',
			'900px': '80vw',
			'800px': '90vw'
		}"
	>
		<ng-template pTemplate="header">
			<div style="width: 100%; text-align: center; font-weight: 600; color: #C42C22;">{{ title }}</div>
		</ng-template>
		@if (loading) {
			<div class="custom-overlay-dialog">
				<p-progressSpinner></p-progressSpinner>
			</div>
		}
		<!-- BODY -->
		<div style="margin: auto; padding-left: 40px; padding-right: 40px; padding-top: 16px">
			<div class="row">
				<div class="col-12">
					<label for="vehicleCategory-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.categories.name' | translate }}
					</label>
					<input
						type="text"
						name="name"
						id="vehicleCategory-name"
						class="form-control"
						[style]="{ width: '100%' }"
						[(ngModel)]="entity.name"
					/>
				</div>
			</div>
		</div>

		<!-- FOOTER -->
		<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight mt-3">
				<div class="p-2 bd-highlight">
					<button class="btn custom-button" [disabled]="!canSave" (click)="save()" i18n>
						{{ 'general.save' | translate }}
					</button>
				</div>
			</div>
		</ng-template>
	</p-dialog>
}
